const numeralLayout = () =>
`
  <NumeralPagination totalItems={2} />
`;

const carouselLayout = () =>
`
  <Carousel totalItems={8} />
`;

const verticalCarouselLayout = () =>
`
  <Carousel vertical totalItems={8} label="Page Name" />
`;

const viewsPerPageLayout = () =>
`
  <ViewsPerPageFilter label="Show" max={10} min={1} />
`;

const linksTemplates = {
  numeral: numeralLayout(),
  carousel: carouselLayout(),
  verticalCarousel: verticalCarouselLayout(),
  viewsPerPage: viewsPerPageLayout(),
};

export default linksTemplates;



// WEBPACK FOOTER //
// ./src/containers/elements/Paginations/constants/paginationsTemplates.js